import React, { useState } from 'react';
import { Form, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../../sessionStorage';

import './AppointmentDialog.scss';

export default function AppointmentDialog(props) {

  const [postingApp, setPosting] = useState(false)
  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;

  const postApp = () => {
    setPosting(true);

    var body = {
      'firstname': props.formState.firstName,
      'lastname': props.formState.lastName,
      'state': props.formState.state,
      'phone': props.formState.phone.replace(/\D/g, ''),
      'email': props.formState.email,
    }

    fetch(`${covrServicesUrl}/api/SeniorMarketSales/Submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
      },
      body: JSON.stringify(body),
    })
      .then(response => response.json())
      .then((data) => {
        if (data.success) {
          props.onNext();
        }
        else {
          setPosting(false);
        }
      }).catch((error) => {
        setPosting(false);
      })
  }
  return (
    <Dialog maxWidth="sm" className="appointment-dialog" open={props.open} onClose={props.onDialogClosed} scroll="body">
      <DialogTitle>Starting Application</DialogTitle>
      <IconButton className="product-info-close-button" aria-label="close" onClick={props.onDialogClosed}>
        <CloseIcon />
      </IconButton>
      <DialogContent className="product-info-dialog-content">
        <p>
          By providing your name and contact information you are consenting to receive calls, text messages and/or emails from a licensed insurance agent about Medicare Plans at the number provided, and you agree such calls and/or text messages may use an auto-dialer or robocall, even if you are on a government do-not-call registry. This agreement is not a condition of enrollment.
        </p>
        <Row className="justify-content-center">
          <Form.Group>
            {postingApp ?
              <div className="submit-loading-container"><CircularProgress /></div> :
              <Button variant="contained" color="primary" onClick={postApp} fullWidth>REQUEST MY APPOINTMENT</Button>
            }
          </Form.Group>
        </Row>
      </DialogContent>
    </Dialog>
  );
}

AppointmentDialog.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onDialogClosed: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Quoters/Medicare/Helpers/AppointmentDialog.js